module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";
	require('widget/copyright')(fox);
	require('widget/captcha')(fox);
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./dependencies/publisher.js
// module id = 140
// module chunks = 5